// スクロールイベントの設定
function handleScroll() {
  const businessSection = document.getElementById('business');
  const customerSection = document.getElementById('customer');
  const businessNavItem = document.querySelector('.p-content__nav-item[data-id="business"]');
  const customerNavItem = document.querySelector('.p-content__nav-item[data-id="customer"]');

  if (!businessSection || !customerSection || !businessNavItem || !customerNavItem) {
    return; // いずれかの要素が存在しない場合は何もしない
  }
  const offset = -40;
  const customerSectionTop = customerSection.getBoundingClientRect().top;
  if (customerSectionTop + offset <= 0) {
    businessNavItem.classList.remove('is-current');
    customerNavItem.classList.add('is-current');
  } else {
    businessNavItem.classList.add('is-current');
    customerNavItem.classList.remove('is-current');
  }
}

// ナビゲーションリストのY座標の設定
function handleNavListY() {
  const navList = document.querySelector('.p-content__nav-list');
  if (!navList) {
    return; // ナビゲーションリストが存在しない場合は何もしない
  }
  
  const navListY = navList.getBoundingClientRect().top + window.scrollY;
  const offset = 40;

  function updateHeightDifference() {
    const scrollY = window.scrollY;
    if (scrollY > navListY) {
      const heightDifference = scrollY - navListY;
      document.documentElement.style.setProperty('--height-difference', `${heightDifference + offset}px`);
      document.body.classList.add('is-menu-fixed'); // bodyにクラスを付与
    } else {
      document.documentElement.style.removeProperty('--height-difference');
      document.body.classList.remove('is-menu-fixed'); // クラスを削除
    }
  }

  window.addEventListener('scroll', updateHeightDifference);
}


// 初期化関数
function init() {
  document.addEventListener('scroll', handleScroll);
  handleNavListY();
}

// ドキュメント読み込み後に初期化関数を実行
document.addEventListener('DOMContentLoaded', init);




document.addEventListener('DOMContentLoaded', function() {
  // クラス名で全てのリンクを取得
  const scrollLinks = document.querySelectorAll('.js-scroll-link');
  scrollLinks.forEach(link => {
      link.addEventListener('click', function(event) {
          event.preventDefault(); // デフォルトのリンク動作をキャンセル

          // スクロール先の要素を取得
          const targetId = this.getAttribute('href').substring(1); // #customer から customer を取得
          const target = document.getElementById(targetId);
          if (target) {
              // ページ先頭からの位置を取得
              const rect = target.getBoundingClientRect();
              const pageOffsetTop = window.pageYOffset + rect.top;
              
              // 現在のスクロール位置
              const currentScrollPosition = window.pageYOffset;

              // オフセット設定
              const offsetDown = 30; // 下方向スクロール用オフセット
              const offsetUp = 180;  // 上方向スクロール用オフセット
              let scrollOffset;

              if (pageOffsetTop > currentScrollPosition) {
                  // 下方向スクロール
                  scrollOffset = offsetDown;
              } else {
                  // 上方向スクロール
                  scrollOffset = offsetUp;
              }

              // スムーススクロールを実行
              window.scrollTo({
                  top: pageOffsetTop - scrollOffset,
                  behavior: 'smooth'
              });
          }
      });
  });
});